import { VegaFont } from '@globalpayments/vega-react';
import Event from './Event';
import { event } from './Interfaces';
import React from 'react';

interface Props {
  events: event[];
  animate: boolean;
}

const EventTab: React.FC<Props> = ({ events, animate }) => {
  if (events.length === 0) {
    return <VegaFont as="p" color="text-secondary" variant="font-h5">No event logs available.</VegaFont>;
  }

  return (
    <>
      {events.map((event, index) => (
        <Event key={index + event.dateUTC} event={event} delay={10 + index * 5} animate={animate} />
      ))}
    </>
  );
};

export default EventTab;